export var ESendValidationCodeStatus;

(function (ESendValidationCodeStatus) {
  ESendValidationCodeStatus["Initial"] = "initial";
  ESendValidationCodeStatus["Loading"] = "loading";
  ESendValidationCodeStatus["Succeed"] = "succeed";
  ESendValidationCodeStatus["Failed"] = "failed";
})(ESendValidationCodeStatus || (ESendValidationCodeStatus = {}));